/* eslint-disable max-len */
/* eslint-disable max-statements */

jQuery.browser = {};

jQuery(function() {
  // 'use strict';

  if (!window.checks.editMode()) {
    jQuery('body').addClass('js');
  }
});

/* eslint-enable */
